import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, X as CloseIcon, BellIcon, SearchIcon, PlaneIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-blue-800 text-white shadow-md" data-id="element-77">
      <div className="container mx-auto px-4 py-3" data-id="element-78">
        <div className="flex justify-between items-center" data-id="element-79">
          <Link to="/" className="flex items-center space-x-2" data-id="element-80">
            <PlaneIcon className="h-8 w-8" data-id="element-81" />
            <span className="text-xl font-bold" data-id="element-82">FlightTracker</span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-83">
            <Link to="/" className="hover:text-blue-200 transition-colors" data-id="element-84">
              Home
            </Link>
            <Link to="/search" className="hover:text-blue-200 transition-colors" data-id="element-85">
              Search Flights
            </Link>
            <Link to="/alerts" className="hover:text-blue-200 transition-colors" data-id="element-86">
              Set Alerts
            </Link>
            <Link to="/my-alerts" className="hover:text-blue-200 transition-colors" data-id="element-87">
              My Alerts
            </Link>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-88">
            <button className="p-2 rounded-full hover:bg-blue-700 transition-colors" data-id="element-89">
              <SearchIcon className="h-5 w-5" data-id="element-90" />
            </button>
            <button className="p-2 rounded-full hover:bg-blue-700 transition-colors" data-id="element-91">
              <BellIcon className="h-5 w-5" data-id="element-92" />
            </button>
            <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md transition-colors" data-id="element-93">
              Sign In
            </button>
          </div>
          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 rounded-md hover:bg-blue-700 transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-94">
            {isMenuOpen ? <CloseIcon className="h-6 w-6" data-id="element-95" /> : <MenuIcon className="h-6 w-6" data-id="element-96" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden mt-3 pb-3" data-id="element-97">
            <div className="flex flex-col space-y-3" data-id="element-98">
              <Link to="/" className="hover:bg-blue-700 px-3 py-2 rounded-md transition-colors" data-id="element-99">
                Home
              </Link>
              <Link to="/search" className="hover:bg-blue-700 px-3 py-2 rounded-md transition-colors" data-id="element-100">
                Search Flights
              </Link>
              <Link to="/alerts" className="hover:bg-blue-700 px-3 py-2 rounded-md transition-colors" data-id="element-101">
                Set Alerts
              </Link>
              <Link to="/my-alerts" className="hover:bg-blue-700 px-3 py-2 rounded-md transition-colors" data-id="element-102">
                My Alerts
              </Link>
              <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md text-left transition-colors" data-id="element-103">
                Sign In
              </button>
            </div>
          </nav>}
      </div>
    </header>;
};
export default Header;